import { createEffect, JSX } from "solid-js";
import c from "class-c";

import GoogleMaps from "@repo/utils-client/external/GoogleMaps";

import GoogleMapsSolid from "../GoogleMapsSolid";

import styles from "./Map.module.scss";

declare namespace Map {
  type Props = {
    class?: string;
    place: GoogleMaps.Place | undefined;
    height: JSX.CSSProperties["height"];
  };
}
function Map({ place, height, class: className }: D<Map.Props>) {
  const googleMaps = GoogleMapsSolid.useContext();

  let ref: HTMLDivElement = undefined!;

  createEffect(async () => {
    if (!place) return;

    const client = await googleMaps.load();

    const map = new client.Map(ref, {
      zoom: 16,
      center: place.location,
      clickableIcons: false,
      disableDefaultUI: true,
      draggable: false,
    });

    // Use `Marker` instead of `marker.AdvancedMarkerElement`, the latter
    // requires the map to be loaded with a `mapId` which costs money. Loading
    // without `mapId` is free
    new client.Marker({
      map,
      position: place.location,
    });
  });

  return (
    <div
      ref={ref}
      style={{ "--height": height }}
      class={c`${styles.map} ${place && styles.show} ${className}`}
    />
  );
}

export default Map;
